import './ClientBlock'
import './components/cookiebar'

import initializeMenu from './menu'
import initializeCarousel from './carousel'
import initializeScroll from './scroll'
import initializeExpanders from './expander'
import initializeParallax from './parallax'
import initializeMaps from './maps'

window.addEventListener('DOMContentLoaded', (event) => {
    initializeMenu()
    initializeCarousel()
    initializeScroll()
    initializeParallax()
    initializeExpanders()
    initializeMaps()
    handleSplashText()
    handleVideoClick()
    handleCardButtons()


    const cells = Array.from(document.querySelectorAll('#websites div.cell'))
    if (!cells[0]) return
    for (let i = 0; i < cells.length; i++) {
        const cell = cells[i]
        cell.addEventListener('click', () => { })
    }
})

function handleSplashText() {
    const splashTexts = Array.from(document.querySelectorAll('p.splash-text'))
    if (splashTexts.length === 0) return

    setInterval(_ => {
        const first = document.getElementById("splash-0")
        const active = document.querySelector('p.splash-text.active')
        if (!active) {
            // set active
            first.classList.add('active')
        } else {
            // move to next
            active.classList.remove('active')

            let id: string | number = active.id.replace("splash-", "")
            id = parseInt(id)
            id = id += 1
            if (splashTexts.length == id) {
                // Last? set first active again
                first.classList.add('active')
            } else {
                let next = document.getElementById(`splash-${id}`)
                next.classList.add('active')
            }
        }
    }, 5000)
}

// RTL7 clicks
function handleVideoClick() {
    const lightbox = document.querySelector('web-lightbox lb-content')
    const openVid = Array.from(document.querySelectorAll('.openrtl7')) as HTMLElement[]
    const url = document.querySelector('#openrtl7link div')

    if (!openVid || !lightbox) {
        return
    }
    const node = document.createElement('iframe')
    node.src = url.textContent;
    node.width = '100%'
    node.height = '100%'
    node.allowFullscreen = true

    for (let i = 0; i < openVid.length; i++) {
        const element = openVid[i];

        element.addEventListener('click', (e) => {
            lightbox.parentElement.classList.add('active')

            lightbox.appendChild(node)
        })
    }
}

// jobs & stages buttons at the bottom
function handleCardButtons() {
    const lightbox = document.querySelector('web-lightbox lb-content')
    const buttonCard = Array.from(document.querySelectorAll('.button-card')) as HTMLElement[]

    if (!buttonCard) {
        return
    }

    for (let i = 0; i < buttonCard.length; i++) {
        const button = buttonCard[i]

        button.addEventListener('click', (e) => {
            if (button.dataset.item == "1") {
                var innerhtml = '<div id="vacature1"><h2>Jobs &amp; stages</h2><p>Enthousiaste en gedreven ontwerpers en ontwikkelaars voorapps, films, animaties en websites hebben altijd onze interesse, <br>ook als we geen vacature hebben. <span style="width:100%; height: 10px; display: block;"><span> Zoek je werk of een stageplek op ons vakgebied? Wil je op freelance basis met ons samenwerken? Maak een afspraak en kom kennismaken!</p><a href="mailto://jobs@appstudio.nl">jobs@appstudio.nl</a></div>'

                lightbox.innerHTML = innerhtml
            } else {
                var innerhtml = '<div id="vacature2"><h2>Jobs at AppStudio.nl</h2><p><span style="font-size:18px;">Laat je inspireren!</span><br><br>Het beeld dat je voor ogen hebt, <br>de keuzes die jij maakt en vooral de details, <br>de details die zo belangrijk zijn en <br>waar je dus écht het onderscheid mee maakt.<br><br>Wil jij mensen versteld laten staan?<br><br><span style="font-size:18px;">AppStudio zoekt een junior web/app developer.</span><br><br>Een paar keywords:</p><ul style="margin-bottom: 20px;display: block; margin: 0 auto; width: 340px; font-size: 12px; max-width: 60%; text-align: center; list-style: none; padding: 8px; margin-bottom: 20px;"><li style="border: 1px solid white;margin-bottom: 5px;">Programmeur</li><li style="border: 1px solid white;margin-bottom: 5px;">iOS / Android / Windows Phone</li><li style=" border: 1px solid white;margin-bottom: 5px;">HTML5, PHP, CSS3, JavaScript</li><li style=" border: 1px solid white;margin-bottom: 5px;">HBO werk- en denkniveau</li><li style=" border: 1px solid white;margin-bottom: 5px;">Leergierig en communicatief</li><li style="border: 1px solid white;margin-bottom: 5px;">Creatief in oplossingen</li></ul><p style="text-align: center;color: white; margin: 0 auto;display: block; font-size:13px; padding-bottom: 30px;  text-shadow: none;line-height: 18px;">Herken je jezelf in bovenstaande?<br> Neem dan contact met ons op om kennis te maken.<br> Mail je CV en motivatie naar:<a style="  text-align: center;  color: white;  text-decoration: underline;  margin: 0 auto;display: block; font-size:13px;" href="mailto:info@appstudio.nl" class="ui-link">info@appstudio.nl</a> <br><b>AppStudio.nl</b><br> Contactpersoon: Milan Boulogne <br> T. 079 – 361 77 80 <br>E. <a style="  text-align: center;  color: white;  text-decoration: underline;  margin: 0 auto;display: inline-block; font-size:13px; width:auto;" href="mailto:info@appstudio.nl" class="ui-link">info@appstudio.nl</a></p></div>'

                lightbox.innerHTML = innerhtml
            }

            lightbox.parentElement.classList.add('active')
            lightbox.parentElement.classList.add('cards')
            lightbox.parentElement.classList.add('vac-2')
        })
    }
}
